import * as React from "react";
import { Button } from "../../atoms";

import "./size-selection.scss";

interface ISizeSelectionProps {
  sizes: string[];
  onSizeSelection: (size: string) => void;
  selectedSize?: string;
}
export const SizeSelection: React.FC<ISizeSelectionProps> = ({
  sizes,
  selectedSize,
  onSizeSelection
}) => {
  return (
    <div className="size-selection">
      {sizes.map((size: string) => (
        <Button
          key={size}
          theme={selectedSize === size ? "dark" : "primary"}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onSizeSelection(size);
          }}
        >
          {size}
        </Button>
      ))}
    </div>
  );
};
